// ── AdSense ──────────────────────────────────────
export const ADSENSE_CLIENT = process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-8383910619750608';

// Size-wise ad slot IDs
export const AD_SLOTS = {
  '728x90':  process.env.REACT_APP_AD_728x90  || '6784508920',
  '468x60':  process.env.REACT_APP_AD_468x60  || '4229378215',
  '320x50':  process.env.REACT_APP_AD_320x50  || '6200935433',
  '300x250': process.env.REACT_APP_AD_300x250 || '6950599574',
  '300x600': process.env.REACT_APP_AD_300x600 || '2373786665',
  'preplay': process.env.REACT_APP_AD_PREPLAY  || '6200935433',
};

// ── Gamezop ───────────────────────────────────────
export const GAMEZOP = {
  API_URL:      process.env.REACT_APP_GAMEZOP_API_URL      || 'https://pub.gamezop.com/v3/games',
  ID_PRIMARY:   process.env.REACT_APP_GAMEZOP_ID_PRIMARY   || '9632',
  ID_SECONDARY: process.env.REACT_APP_GAMEZOP_ID_SECONDARY || '11190',
};

// ── GamePix ───────────────────────────────────────
export const GAMEPIX = {
  API_URL: process.env.REACT_APP_GAMEPIX_API_URL || 'https://feeds.gamepix.com/v2/json',
  SID:     process.env.REACT_APP_GAMEPIX_SID     || 'G2A5E',
};

// ── Site ──────────────────────────────────────────
export const SITE = {
  URL:  process.env.REACT_APP_SITE_URL  || 'https://thegamezone.fun',
  NAME: process.env.REACT_APP_SITE_NAME || 'TheGameZone',
};

// ── Category → emoji icon map ─────────────────────
export const CATEGORY_ICONS = {
  'action':        '⚔️',
  'adventure':     '🗺️',
  'arcade':        '🕹️',
  'puzzle':        '🧩',
  'racing':        '🏎️',
  'sports':        '⚽',
  'shooting':      '🎯',
  'strategy':      '♟️',
  'casual':        '🎲',
  'multiplayer':   '👥',
  'card':          '🃏',
  'board':         '🎰',
  'educational':   '📚',
  'simulation':    '🏗️',
  'rpg':           '🧙',
  'horror':        '👻',
  'cooking':       '🍳',
  'dress-up':      '👗',
  'io':            '🌐',
  'hypercasual':   '⚡',
  'stickman':      '🏃',
  'clicker':       '👆',
  'escape':        '🚪',
  'football':      '⚽',
  'basketball':    '🏀',
  'cricket':       '🏏',
  'car':           '🚗',
  'bike':          '🏍️',
  'running':       '🏃',
  'jumping':       '🦘',
  'tower-defense': '🏰',
  'zombie':        '🧟',
  'default':       '🎮',
};

export const getCategoryIcon = (cat = '') =>
  CATEGORY_ICONS[cat.toLowerCase().replace(/\s+/g, '-')] || CATEGORY_ICONS.default;

// ── Tag → emoji icon map ──────────────────────────
export const TAG_ICONS = {
  'crazy':          '🤪',
  'action':         '⚔️',
  'logic':          '🧠',
  'strategy':       '♟️',
  'arcade':         '🕹️',
  'number':         '🔢',
  'puzzle':         '🧩',
  'adventure':      '🗺️',
  'tower defense':  '🏰',
  'shooting':       '🎯',
  '3d':             '🎲',
  'casual':         '☁️',
  'racing':         '🏎️',
  'sports':         '⚽',
  'board':          '🎰',
  'featured':       '⭐',
  'girl':           '👧',
  'fun':            '😄',
  'kids':           '👶',
  'hard':           '💪',
  'easy':           '😊',
  'fast':           '⚡',
  'free':           '🆓',
  'online':         '🌐',
  'new':            '🆕',
  'hot':            '🔥',
  'top':            '🏆',
  'popular':        '📈',
  'trending':       '🔺',
  '2d':             '📐',
  'html5':          '💻',
  'mobile':         '📱',
  'default':        '🏷️',
};

export const getTagIcon = (tag = '') =>
  TAG_ICONS[tag.toLowerCase()] || TAG_ICONS.default;

// ── Helpers ───────────────────────────────────────
export const slugify = (text) =>
  text?.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-') || '';
